import React, { useEffect, useState } from "react";
import "../../assets/styles/local/DashBoard.css";
import { useSelector, useDispatch } from "react-redux";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import {
  FetchInventory,
} from "../../redux/actions/action";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const InventoryCard = () => {
  const dispatch = useDispatch();
  const companyid = window.localStorage.getItem("companyid");
  const inventoryDetails = useSelector((state) => state.user.fetch365Inventory);
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("BI-Dashboard-List").then(data => setFetchTranslationList(data));
  }, []);

  useEffect(() => {
    dispatch(FetchInventory(companyid));
  }, [dispatch, companyid]);

  const Inventory = useSelector((state) => state.user.FetchInventory);
  return (
    <>
      <div className="inventoryCard inventoryCard_Res">
        <div className="inventoryTitle">
          <span>
            {/* Inventory */}
            {t("Inventory")}
          </span>
          <span> | </span>
          <span>
            {/* Last 365 Days */}
            {t("Last 365 Days")}
          </span>
        </div>
        {inventoryDetails?.map((inventory, index) => (
          <div key={index} className="inventoryDetails">
            <div className="inventory">
              <div
                className="circle"
                style={{
                  "--circle-percentage": `${inventory.inStockPercentage}%`,
                }}
              ></div>
              <p>
                {/* IN STOCK */}
                {t("In Stock")}
              </p>
              <text>{europeanFormatWithSymbol(inventory.inStockAmount)}</text>
            </div>
            <div className="inventory">
              <div
                className="circle"
                style={{
                  "--circle-percentage": `${inventory.poAwaitingPercentage}%`,
                }}
              ></div>
              <p>
                {/* PO AWAITING */}
                {t("PO AWAITING")}
              </p>
              <text>
                {europeanFormatWithSymbol(inventory.poAwaitingAmount)}
              </text>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default InventoryCard;
